export default class LoginResponse {
  type: string;
  token: string;
  operationResult: boolean;
  errorMsg?: string;
  errorCode?: string;

  constructor(data: any) {
    this.type = data.type || "";
    this.token = data.token || "";
    this.operationResult = !!data.operationResult;
    this.errorMsg = data.errorMsg;
    this.errorCode = data.errorCode;
  }

  toJSON() {
    return {
      type: this.type,
      token: this.token,
      operationResult: this.operationResult,
      errorMsg: this.errorMsg,
      errorCode: this.errorCode,
    };
  }
}
